import React from 'react';
import {Table, Input, Checkbox, Button, Dropdown} from 'semantic-ui-react';
import {warranties, PAYCODE_OPTIONS} from '../../../../constants';

const DisplayData = ({
  item,
  id,
  handleUpdatePrincipalWorks,
  handleUpdatePaycode,
  handleUpdateFlat,
  disabledBtns,
  handleRemoveItem,
}) => {
  const {
    taskId,
    flatDealer,
    principalTask,
    description,
    flatTde,
    flatInternal,
    paycode,
    hours,
  } = item;

  const total = (flatTde * warranties.hour_price).toFixed(2);
  return (
    <Table.Row key={id}>
      <Table.Cell>
        <Checkbox
          disabled={disabledBtns}
          onChange={(e, data) => handleUpdatePrincipalWorks(data, item)}
          checked={principalTask === 'S'}
        />
      </Table.Cell>
      <Table.Cell>{taskId}</Table.Cell>
      <Table.Cell>{description}</Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input value-input'
          placeholder='Flat Dealer'
          value={flatDealer || hours || 0}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          disabled={disabledBtns}
          onChange={(e, {value}) =>
            handleUpdateFlat('flatDealer', value, item)
          }
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input value-input'
          placeholder='Flat TDE'
          value={flatTde || hours || 0}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          disabled={disabledBtns}
          onChange={(e, {value}) => handleUpdateFlat('flatTde', value, item)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-works-input value-input'
          placeholder='Flat Internal'
          value={flatInternal || 0}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          disabled={disabledBtns}
          onChange={(e, {value}) =>
            handleUpdateFlat('flatInternal', value, item)
          }
        />
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {total}
      </Table.Cell>
      <Table.Cell>
        <Dropdown
          selection
          placeholder='Paycode'
          value={paycode}
          options={PAYCODE_OPTIONS}
          onChange={(e, {value}) => handleUpdatePaycode(value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={disabledBtns}
          onClick={() => handleRemoveItem(id)}
          size='mini'
          color='red'
        >
          Eliminar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

export default DisplayData;
